import { useEffect } from 'react';
/** Lock the play area while mobile browser chrome expands/collapses. Recompute for
 * width/orientation changes, or genuine desktop window resizes; never on notices. */
export function useGameViewport(active: boolean) {
  useEffect(() => {
    if (!active) return;
    let width = window.innerWidth;
    const update = () => {
      // svh represents the safe viewport WITH browser chrome, even when opened
      // with the address bar hidden. Capturing it prevents later toolbar overlap.
      const probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;height:100svh;width:0';
      document.body.append(probe);
      const safeHeight = probe.getBoundingClientRect().height;
      probe.remove();
      document.documentElement.style.setProperty('--game-height', `${Math.min(window.innerHeight, safeHeight || window.innerHeight)}px`);
    };
    const resize = () => {
      if (window.innerWidth !== width || !matchMedia('(pointer: coarse)').matches) { width = window.innerWidth; update(); }
    };
    update();
    window.addEventListener('resize', resize);
    screen.orientation?.addEventListener('change', update);
    document.addEventListener('fullscreenchange', update);
    return () => { window.removeEventListener('resize', resize); screen.orientation?.removeEventListener('change', update); document.removeEventListener('fullscreenchange', update); };
  }, [active]);
}
